<template>
  <n-config-provider :theme-overrides="themes">
    <n-loading-bar-provider>
      <n-dialog-provider>
        <n-notification-provider>
          <n-message-provider>
            <slot />
          </n-message-provider>
        </n-notification-provider>
      </n-dialog-provider>
    </n-loading-bar-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { naiveThemes } from './naiveui.themes'

const themes = reactive({
  ...naiveThemes,
})
</script>

<style lang="less">
#app {
  height: 100vh;
}
</style>
